module.exports = __webpack_public_path__ + "img/acms-work-flow.5c774b68.svg";